
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experience-of-therapy/cognitive-behavioural-therapy-cbt",
      function () {
        return require("private-next-pages/experience-of-therapy/cognitive-behavioural-therapy-cbt/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/experience-of-therapy/cognitive-behavioural-therapy-cbt"])
      });
    }
  